import { render, staticRenderFns } from "./role.vue?vue&type=template&id=3690e6dc&"
import script from "./role.vue?vue&type=script&lang=js&"
export * from "./role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3690e6dc')) {
      api.createRecord('3690e6dc', component.options)
    } else {
      api.reload('3690e6dc', component.options)
    }
    module.hot.accept("./role.vue?vue&type=template&id=3690e6dc&", function () {
      api.rerender('3690e6dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sys/role.vue"
export default component.exports